import type { FaireProductEntity } from "../../entity_types/product";

export const p_wszupsab55: FaireProductEntity = {
  token: "p_wszupsab55",
  type: "product",
  name: "Como Marble Trinket Tray / Jewelry Holder (Ships from Uk)",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/6382fc694846a1f670b75f4cb73432595f03e035030341b0178088b045de9ac4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f6a5172ae7a533159eee0df8eb702656d57ac29980665166fbf6a16f4bb4f193.jpeg",
    "https://cdn.faire.com/fastly/f56c4e25c8a0f8deb36b122a7f5d3aec0fb4ccfc9c879b532f12266c21819e3d.jpeg",
    "https://cdn.faire.com/fastly/0fb0ae6a6ad46858e71b74c1752176ae707aeb594b529b51e24b3549dce7c2dd.jpeg",
    "https://cdn.faire.com/fastly/857571b249f7fef9071f488b7cb474ac32abc447098f475bbcd0c375ae492232.jpeg",
    "https://cdn.faire.com/fastly/853945ef5487f1800e16416330c8456d8c423f6aa76f5d87045de0d79a7b92d2.jpeg",
  ],
  priceDollars: 24.36,
  description:
    "PLEASE NOTE THAT THIS ITEM WILL BE SHIPPING FROM OUR UK WAREHOUSE\n\nCOMO tray is a functional open storage object for your jewellery, keys, earphones or coins. Bringing simplicity and a sense of calm to your home. Each COMO tray is handcrafted from a solid piece of beautiful marble with a sophisticated matte honed finish.\n\nThe tray is double-sided.\n\nProduct information\n\nPlease note that due to the nature of the material, colour and pattern variation will occur. Giving you a truly unique piece. Our photos should be used as a guide.\n\nDimensions: H35 x D180mm\nMaterial: Marble",
  tags: [],
  msrpDollars: 58,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:19.754Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
